import loader from "../../../../microAnims/loader.json";
import { flatten } from "lottie-colorify";

export default {
  props: ["type"],
  data() {
    return {
      loader: JSON.stringify(loader),
    };
  },

  created() {
    let companyColor = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--companyColor");

    if (companyColor) {
      companyColor = companyColor.replace(" ", "");

      if (this.type !== "dark") {
        if (companyColor !== "#000000" && companyColor) {
          this.loader = JSON.stringify(flatten(companyColor, loader));
        }
      } else {
        this.loader = JSON.stringify(flatten("#ffffff", loader));
      }
    }
  },
};
